import { createContext } from 'react';

export const ProjectInfoContext = createContext("");